import type { SharedFile } from "../../../types/file";
import type { FieldRegistryConfig } from "../../types";
import { FileFieldControl } from "./FileFieldControl/FileFieldControl";

export type FileFieldValue = SharedFile[];

export const fileFieldConfig: FieldRegistryConfig<FileFieldValue> = {
  icon: "attachment",
  control: FileFieldControl,
  toReviewString: (value) =>
    Array.isArray(value)
      ? value
          .map((file) => file?.metadata?.filename ?? "")
          .filter(Boolean)
          .join(", ")
      : "",
};
